import { render, staticRenderFns } from "./message-send-box.vue?vue&type=template&id=15f5623e&"
import script from "./message-send-box.vue?vue&type=script&lang=js&"
export * from "./message-send-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports